import React, { useMemo } from 'react'
import OneMentorVideoAndOther from './layouts/OneMentorVideoAndOther'

export default function CorrectLayoutHandler({ layout, ...rest }) {
  const ComponentToRender = useMemo(() => {
    // todo: add more layouts in the future. (Without video and all)
    return OneMentorVideoAndOther
  }, [layout])

  return <ComponentToRender {...rest} />
}
